import { render } from "./AdicionarServicoPassanteModal.vue?vue&type=template&id=4d24ffbf&ts=true"
import script from "./AdicionarServicoPassanteModal.vue?vue&type=script&lang=ts"
export * from "./AdicionarServicoPassanteModal.vue?vue&type=script&lang=ts"

import "./AdicionarServicoPassanteModal.vue?vue&type=style&index=0&id=4d24ffbf&lang=scss"

import exportComponent from "C:\\xampp8.1\\htdocs\\acampa-gestao-pra\\vuecode\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__